/* eslint-disable prettier/prettier */

export const AttachmentType = {
  1: 'Detached',
  2: 'Attached',
  3: 'Attached',
  4: 'Attached',
  5: 'Attached',
  6: 'Attached',
  7: 'Attached',
  8: 'Attached',
  9: 'Attached',
  10: 'Detached',
  11: 'Detached',
  12: 'Detached',
  13: 'Detached',
  14: 'Detached',
  15: 'Attached',
  16: 'Detached',
} as const;

export const LoanPurposeType = {
  1: 'Purchase',
  2: 'Refinance',
  3: 'Refinance',
  4: 'Purchase',
  5: 'Purchase',
} as const;

export const PropertyUsageType = {
  1: 'PrimaryResidence',
  2: 'SecondHome',
  3: 'Investment',
  4: 'N/A',
  5: 'N/A'
} as const;

export const ProjectLegalStructureType = {
  5: 'Condominium',
  6: 'Condominium',
  7: 'Condominium',
  9: 'Cooperative',
  12: 'Condominium'
} as const;

export const AssetDocumentationLevelIdentifierType = {
  100: 'StatedAndVerified',
  50: 'StatedOnly',
  0: 'NotRequired'
} as const;

export const IncomeDocumentationLevelIdentifierType = {
  100: 'StatedAndVerified',
  70: 'StatedOnly',
  60: 'StatedOnly',
  50: 'StatedOnly',
  0: 'NeitherStatedNorVerified',
} as const;

export const LoanProgramIdentifierType = {
 20: 'HomePossibleMortgage'
} as const;

export const ConstructionLoanType = {
  4: 'ConstructionOnly',
  5: 'ConstructionToPermanent',
} as const;

export const CommunityLendingProductType = {
  556: 'HomeReady',
} as const;
